import { FontSizes, makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  contentWrapper:{
    paddingTop:24
  },
  tagsContainer: {
    paddingTop: 24,
  },
  tagsContent: {
    margin: '0px -20px',
    padding: 20,
  },
  emptyTagsView: {
    padding: 20,
    width: '780px',
    fontSize: FontSizes.size16,
    borderWidth: 1,
    borderColor: theme.palette.neutralLight,
    borderStyle: 'solid',
    textAlign: 'center',
  },
  closeButton: {
    color: theme.palette.neutralDark,
  },
  commandBarButton: {
    height: 40,
  },
  customWidth: {
    width: '600px',
  },
}));
